import React, { useState, useHistory } from 'react';
import Image from 'next/image';
import SMMPricing from '../../components/smm/SMMPriceing';
import SMMCustomProposal from '../../components/smm/CustomProposal';
import { useRouter } from 'next/router';

function Proposal(props) {
  const router = useRouter();
  const [step, setStep] = useState(1);
  const [showSMMPricingModal, setShowSMMPricingModal] = useState(false);
  const [loadedSmmGetPricingModal, setLoadedSmmGetPricingModal] = useState(false);
  const [showSMMCustomProposalModal, setShowSMMCustomProposalModal] = useState(false);
  const [loadedCustomProposalModal, setLoadedCustomProposalModal] = useState(false);

  const hideSMMPricingModal = () => {
    setShowSMMPricingModal(false);
    setLoadedSmmGetPricingModal(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
  };
  const hideSMMCustomProposalModal = () => {
    setShowSMMCustomProposalModal(false);
    setLoadedCustomProposalModal(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    document.getElementById('offer-form-smm-custom').reset();
  };

  const showSMMPricing = () => {
    if (this.props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/smm-pricing';
    } else {
      setStep(1);
      setShowSMMPricingModal(true);
      document.getElementById('offer-form-smm').reset();
      document.body.style.overflow = 'hidden';
    }
  };
  const showSMMCustomProposal = () => {
    if (this.props.width < 768) {
      window.location.href = '/social-media-marketing/proposals/smm-custom-proposal';
    } else {
      setStep(1);
      setShowSMMCustomProposalModal(true);
      document.getElementById('offer-form-smm-custom').reset();
      document.body.style.overflow = 'hidden';
    }
  };
  const redirectTo = from => {
    if (from == 'pricing') router.push('/social-media-marketing/proposals/smm-pricing?platform=' + props.service);
    else router.push('/social-media-marketing/proposals/smm-custom-proposal?platform=' + props.service);
  };
  return (
    <>
      <div className="hidden md:block bg-white md:bg-grid py-23">
        <div className="container">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <div className="text-center">
              <p className="text-18 md:text-24 font-medium">
                Answer a few questions and get a<br></br>custom proposal for {props.service}
              </p>

              <button
                className="relative hidden md:inline-block bg-purple border-2 border-purple hover:bg-transparent hover:border-purple transition-all transition-400 text-white px-30 py-7 text-18 rounded-md mt-15 icon-paper-container overflow-hidden cursor-pointer"
                onClick={() => (props.width < 768 ? redirectTo('pricing') : setShowSMMPricingModal(true))}
              >
                <span className="icon icon-paper"></span>

                <span className="text block">Get Pricing</span>
              </button>
              <button
                className="relative ml-15 hidden md:inline-block bg-purple border-2 border-purple hover:bg-transparent hover:border-purple transition-all transition-400 text-white px-30 py-7 text-18 rounded-md mt-15 icon-paper-container overflow-hidden cursor-pointer"
                onClick={() => (props.width < 768 ? redirectTo('custom') : setShowSMMCustomProposalModal(true))}
              >
                <span className="icon icon-paper"></span>

                <span className="text block">Get your proposal</span>
              </button>
            </div>

            <div className="relative md:ml-50 mt-10 md:mt-10">
              <Image src={props.image} layout="intrinsic" width={225} height={225} alt="social-media" />
            </div>

            <div className={'flex flex-col'}>
              <button
                className="inline-block md:hidden bg-green hover:bg-purple transition-all transition-400 text-white px-30 py-7 text-16 rounded-md mt-10 cursor-pointer"
                onClick={() => redirectTo('pricing')}
              >
                Get Pricing
              </button>
              <button
                className="inline-block md:hidden bg-green hover:bg-purple transition-all transition-400 text-white px-30 py-7 text-16 rounded-md mt-10 cursor-pointer"
                onClick={() => redirectTo('custom')}
              >
                Get Custom Proposal
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="block md:hidden container py-23 pt-10">
        <a
          onClick={() => redirectTo('custom')}
          className={
            'bg-green-badge text-center hover:bg-green-hover inline-block w-full  transition-all transition-400 text-white   px-23 py-8 text-16 rounded-md'
          }
        >
          Get a Proposal
        </a>
      </div>
      <SMMPricing
        step={step}
        country={props.country}
        platform={props.service}
        show={showSMMPricingModal}
        title="Get SMM Pricing"
        hide={hideSMMPricingModal}
      />
      <SMMCustomProposal
        step={step}
        country={props.country}
        platform={props.service}
        show={showSMMCustomProposalModal}
        title="Get SMM Pricing"
        hide={hideSMMCustomProposalModal}
      />
    </>
  );
}

export default Proposal;
